<template>
	<button
		type="button"
		class="inline-flex gap-2 items-center button small rounded-md bg-blue-100 border-blue-100 shadow-none text-gray-900 hover:bg-blue-50 hover:border-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
		:disabled="inProgress"
		@click="syncAllEnrollments">
		<SvgIcon :class="{ 'animate-spin': inProgress }" icon="arrow-path" size="sm" weight="bold" />
		<span class="text-sm">Sync Enrollments</span>
	</button>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import axios from "axios";
import $events from "@/event-bus.ts";

export default defineComponent({
	props: {
		cloverAdminUuid: {
			type: String,
			required: true,
		},
	},
	methods: {
		syncAllEnrollments() {
			if (this.inProgress) {
				return;
			}

			if (!confirm("Are you sure you want to sync enrollments for all active users? This will be queued and may take some time.")) {
				return;
			}

			this.inProgress = true;

			axios
				.post("/admin/accounts/users/product/enrollments/sync-all", {
					cloverAdminUuid: this.cloverAdminUuid,
				})
				.then(() => {
					$events.$emit("toastNotification", {
						action: "updated",
						heading: "Platform-wide enrollment sync has been queued successfully.",
						status: "saved",
					});
				})
				.catch((e) => {
					$events.$emit("toastNotification", {
						action: "error",
						heading: "Failed to initiate platform-wide enrollment sync.",
						message: e.response?.data?.message || e.message,
						status: "error",
					});
				})
				.finally(() => {
					this.inProgress = false;
				});
		},
	},
	setup() {
		const inProgress = ref(false);

		return {
			inProgress,
		};
	},
});
</script>
